import { placeholder } from "./svg_assets";

export default class ApiUtils {
  static isProduction = false;
  static authority = process.env.REACT_APP_API_URL;

  static getHeader({ token }) {
    let header = {
      // 'User-Agent': 'Skor/1 web',
      "Content-type": "application/json",
      "x-platform": "pwa",
    };

    if (token) {
      header["Authorization"] = `Token ${token}`;
    }
    return header;
  }

  static getHeaderMultipart({ token }) {
    let header = {
      // 'User-Agent': 'Skor/1 web',
      "Content-type": "multipart/form-data",
      "x-platform": "pwa",
    };

    if (token) {
      header["Authorization"] = `Token ${token}`;
    }
    return header;
  }

  static validateImgUrl({ url = "" }) {
    if (url) {
      if (url.includes("https") || url.includes("http")) {
        return url;
      } else {
        return `https://${ApiUtils.authority}${url}`;
      }
    } else {
      return placeholder;
    }
  }
}
